import React, { useEffect, useState } from "react";
import s from "./MySpares.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { getMySpares, getUser, updateUser } from "../../redux/carSlice";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Col, Form, Image, Input, message, Row, Upload } from "antd";
import MySidebar from "../../components/MySidebar/MySidebar";
import SpareItem from "../../components/MySpareItem/MySpareItem";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });

const MySpares = () => {
  const dispatch = useDispatch();

  const mySpares = useSelector((state) => state.cars.mySpares);
  const user = useSelector((state) => state.cars.userDetails);
  const email = useSelector((state) => state.cars.email);
  const [isUpdateUserForm, setIsUpdateUserForm] = useState(false);
  const [form] = Form.useForm();
  const [file, setFile] = useState();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [messageApi, contextHolder] = message.useMessage();
  const { width } = useWindowDimensions();

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Вы обновили информацию о пользователе!",
    });
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type='button'
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  useEffect(() => {
    dispatch(getMySpares());
    dispatch(getUser());
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      first_name: user?.first_name !== undefined ? user.first_name : "",
      last_name: user?.last_name ?? "",
      phone: user?.phone_number ?? "",
      address: user?.address ?? "",
      country: user?.country ?? "",
      city: user?.city ?? "",
      company: user?.company_name ?? "",
    });
  }, [user, form]);

  const sendForm = async (values) => {
    const data = new FormData();
    data.append("first_name", values.first_name);
    data.append("last_name", values.last_name);
    data.append("phone_number", values.phone);
    data.append("address", values.address);
    data.append("country", values.country);
    data.append("city", values.city);
    data.append("company_name", values.company);

    if (file && file.length > 0) {
      file.forEach((it) => {
        data.append("photo", it.originFileObj);
      });
    }

    const res = await dispatch(updateUser(data));

    if (res.type === "user/updateUser/fulfilled") {
      success();
      dispatch(getUser());
      // form.resetFields();
    }
  };

  return (
    <div className={s.addUser}>
      {contextHolder}
      {width > 1000 ? <div className={s.top}>top</div> : null}
      <div className={s.main}>
        {width > 1000 ? <div className={s.left}>left</div> : null}
        <div className={s.center}>
          {width > 750 ? <Header /> : <MobileHeader />}
          <div className={s.contentWrapper}>
            <div className={s.content}>
              <div className={s.sidebar}>
                <MySidebar setIsUpdateUserForm={setIsUpdateUserForm} />
              </div>

              <div className={s.announcements}>
                <div className={s.h4}>Мои запчасти</div>
                <div className={s.myCars}>
                  {Array.isArray(mySpares) && mySpares.length > 0 ? (
                    mySpares?.map((it) => <SpareItem spare={it} />)
                  ) : (
                    <div className={s.noAnnoucements}>
                      Пока нет объявлений...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {width > 1000 ? <div className={s.right}>right</div> : null}
      </div>
      <Footer />
    </div>
  );
};

export default MySpares;
